
import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { useGetTotalQuery } from "../../redux/slice/general/generalStatisca.js";
import { admins, students, employers, studentsteachers } from "../../assetss/task_icons/index.js";
import { useGetStatsistikQuery } from "../../redux/slice/students/Statsistik.js";

const Card = ({ title, value, debts, img, delay }) => {
    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <div
            data-aos="fade"
            data-aos-delay={delay}
            className="border rounded-xl p-2 bg-white shadow-md container mx-auto items-center shadow-black/30 grid grid-cols-3 transition-all"
        >
            <div className="col-span-2 flex flex-col gap-2">
                <h3 className="text-lg font-semibold text-black whitespace-nowrap">{title}</h3>
                <p className="text-2xl">{value}</p>
                <b>{debts} </b>
            </div>
            <div className="max-w-full ml-auto">
                <img src={img} alt="Icon" className="max-w-full" />
            </div>
        </div>
    );
};

const Recommeditions = () => {
    const { data, isLoading } = useGetStatsistikQuery();
    const storedDataString = sessionStorage.getItem('debts');
    const storedData = storedDataString ? JSON.parse(storedDataString) : [];
    return (
        <div className="grid grid-cols-2 container mx-auto md-lg:grid-cols-3 lg:grid-cols-4 gap-2 mt-3 w-full">

            <React.Fragment>
                {data?.recommendations.map((item)=>{
                    let key=Object.keys(item)[0]
                    return <>
                        <Card delay={500} title={key} value={item?.key?.added_students_count ?? 0} img={students} />
                    </>
                })}

            </React.Fragment>

        </div>
    );
};

export default Recommeditions;


